module.exports = __webpack_public_path__ + "img/second-page-icon-1.3cbc6ecd.svg";